/* eslint-disable react/require-default-props */
import PropTypes from 'prop-types';
import {
  useEffect, useRef, useState, useCallback,
} from 'react';
import styles from './MegaMenu.module.scss';

/**
 * Mega Menu component. For when you need menus over 9000
 */
export default function MegaMenu({
  label,
  left = null,
  center = null,
  right = null,
  theme = 'black',
  open = false,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [closing, setClosing] = useState(false);
  const menuRef = useRef();

  const containerName = [
    styles['mega-menu'],
    isOpen ? styles['--open'] : '',
    left && right == null ? styles['--left-center'] : '',
    left && right ? styles['--left-center-right'] : '',
    left == null && right ? styles['--center-right'] : '',
    styles[`--theme-${theme}`],
    closing ? styles['--closing'] : '',
  ].join(' ');

  const toggle = () => {
    if (isOpen) {
      setClosing(true);
    }
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    if (open) {
      toggle();
    }
  }, [open]);

  const closeIfOutsideClick = useCallback((e) => {
    if ((!menuRef.current.contains(e.target) && isOpen) || (e.target.parentNode !== menuRef.current && isOpen && (e.target.tagName === 'A' || e.target.tagName === 'BUTTON'))) {
      setClosing(true);
      setIsOpen(false);
    }
  }, [isOpen, menuRef]);

  useEffect(() => {
    window.addEventListener('click', closeIfOutsideClick);
    return () => {
      window.removeEventListener('click', closeIfOutsideClick);
    };
  }, [isOpen]);

  return (
    <div className={containerName} ref={menuRef}>
      <button
        className={styles['mega-menu__button']}
        type="button"
        onClick={toggle}
        onAnimationEnd={(e) => {
          if (e.animationName === styles.rotateBack) {
            setClosing(false);
          }
        }}
      >
        {label}
      </button>
      <div className={styles['mega-menu__menu']}>
        <div className={styles['mega-menu__grid']}>
          {left}
          {center}
          {right}
        </div>
      </div>
    </div>
  );
}

MegaMenu.propTypes = {
  /**
   * Button label
   */
  label: PropTypes.string.isRequired,
  /**
   * Open menu
   */
  open: PropTypes.bool,
  /**
   * Left mega menu container
   */
  left: PropTypes.node,
  /**
   * Center mega menu container
   */
  center: PropTypes.node,
  /**
   * Right mega menu container
   */
  right: PropTypes.node,
  /**
   * Color theme of button
   */
  theme: PropTypes.oneOf(['black', 'white']),
};

MegaMenu.styles = {
  cta: styles['mega-menu__cta'],
};
